module.exports = {"210115001":"蒲西街道","210115002":"蒲东街道","210115003":"茨榆坨街道","210115004":"城郊街道","210115101":"于家房镇","210115102":"朱家房镇","210115103":"冷子堡镇","210115104":"刘二堡镇","210115106":"新民屯镇","210115107":"满都户镇","210115108":"杨士岗镇","210115109":"肖寨门镇","210115110":"长滩镇","210115111":"四方台镇","210115113":"六间房镇","210115114":"养士堡镇","210115115":"潘家堡镇","210115117":"老大房镇","210115118":"大黑岗子镇","210115119":"牛心坨镇","210115401":"四方台农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210115.json
// module id = 597
// module chunks = 0